import apiClient from './apiClient';
import { getServerUrl } from '../utils';
import { authEndpoints } from '../constants/endpoint';

export const login = (payload) =>
  apiClient(getServerUrl()).post(authEndpoints.login, payload);
